import classNames from 'classnames'

import * as styles from '../../Breadcrumb.module.css'

export function useBreadcrumbModClassName({
  className,
  isActive,
  isCheckedActive,
  isHead,
  isLinkType,
  isTab,
  isTabActive,
}) {
  return classNames(className, {
    [styles.active]: isActive,
    [styles.checked]: isCheckedActive,
    [styles.head]: isHead,
    [styles.linkType]: isLinkType,
    [styles.tab]: isTab,
    [styles.tabActive]: isTabActive,
  })
}
